import { authedEndpoint } from "~/lib/api/builder";
import { Timezones } from "~/lib/api/schemas/basic-settings";

export const list = authedEndpoint.query(
    () => ({
        url: "settings/timezones",
    }),
    {
        output: Timezones,
    },
);
